import { ActionIcon, Button, Menu, Stack } from '@mantine/core';
import {
  IconAdjustments,
  IconClipboardList,
  IconCreditCard,
  IconLogin,
  IconLogout,
  IconUser,
  IconUserEdit,
} from '@tabler/icons-react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../../../reducers/auth';
import { AppDispatch, RootState } from '../../../../../stores';
import LoginDrawer from '../loginDrawer';
import SnappClubPoints from './components/snappClubPoints';

const getUserGreeting = () => {
  const currentTime = new Date().getHours();

  if (currentTime >= 5 && currentTime < 12) {
    return 'صبح بخیر';
  }

  if (currentTime >= 12 && currentTime < 18) {
    return 'عصر بخیر';
  }

  return 'شب بخیر';
};

const UserButton = () => {
  const dispatch: AppDispatch = useDispatch();

  const [isVisible, setIsVisible] = useState(false);

  const { user } = useSelector((state: RootState) => state.auth);

  const router = useRouter();

  const hasAccessToBo = user?.data && user.data.roles && user.data.roles.length > 1;

  const userGreeting = getUserGreeting();

  const icon = user ? (
    <Menu shadow="md" position="bottom-end">
      <Menu.Target>
        <ActionIcon style={{ zIndex: 5 }} variant="default" size="lg" mt="xs">
          <IconUser />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>
          {userGreeting} {user?.data?.firstName}
        </Menu.Label>

        <Stack gap={4}>
          <SnappClubPoints />

          <Menu.Item
            id="click_edit_profile"
            onClick={() => router.push({ pathname: '/profile/edit', query: { ...router.query } })}
            leftSection={<IconUserEdit size={14} />}
          >
            ویرایش اطلاعات کاربری
          </Menu.Item>
        </Stack>

        <Menu.Item
          id="click_my_order"
          onClick={() => router.push({ pathname: '/profile/orders', query: { ...router.query } })}
          leftSection={<IconClipboardList size={14} />}
        >
          سفارش‌های من
        </Menu.Item>

        <Menu.Item
          id="click_my_transactions"
          onClick={() => router.push({ pathname: '/profile/txs', query: { ...router.query } })}
          leftSection={<IconCreditCard size={14} />}
        >
          تراکنش‌‌های من
        </Menu.Item>

        {hasAccessToBo ? (
          <>
            <Menu.Divider />
            <Link href="/bo">
              <Menu.Item leftSection={<IconAdjustments size={14} />}>مدیریت</Menu.Item>
            </Link>
          </>
        ) : null}

        <Menu.Divider />

        <Menu.Item color="red" onClick={() => dispatch(logout())} leftSection={<IconLogout size={14} />}>
          خروج از حساب کاربری
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  ) : (
    <Button
      style={{ zIndex: 5 }}
      variant="default"
      leftSection={<IconLogin />}
      size="sm"
      mt="xs"
      onClick={() => setIsVisible(true)}
    >
      ورود
    </Button>
  );

  return (
    <>
      {icon}

      <LoginDrawer isVisible={isVisible} setIsVisible={setIsVisible} />
    </>
  );
};

export default UserButton;
